<template>
    <Modal :title="$t('approvalFlowConfigManagement.approvalFlow.flowDataInfo')" v-model="dialogVisible" width="50%" footer-hide>
        <!--一个高亮显示的插件-->
        <codemirror :value="flowJsonData" :options="options" class="code"></codemirror>
    </Modal>
</template>

<script>
    import 'codemirror/lib/codemirror.css'
    import { codemirror } from 'vue-codemirror'
    require("codemirror/mode/javascript/javascript.js")

    export default {
        props: {
            data: Object,
        },
        data() {
            return {
                dialogVisible: false,
                flowJsonData: {},
                options: {
                    mode: {name: "javascript", json: true},
                    lineNumbers: true
                }
            }
        },
        components: {
            codemirror
        },
        methods: {
            init() {
                this.dialogVisible = true
                this.flowJsonData = JSON.stringify(this.data, null, 4).toString()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ef/info.vue